export default __webpack_public_path__ + "static/media/logo.bae4f954.svg";